import * as logLevel from 'loglevel';

export const logger = {
  error: logLevel.error,
  log: logLevel.log,
  info: logLevel.info,
  warn: logLevel.warn
};
